"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var THREE = _interopRequireWildcard(require("three"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ThreeSceneRenderer = /*#__PURE__*/function (_React$Component) {
  _inherits(ThreeSceneRenderer, _React$Component);

  var _super = _createSuper(ThreeSceneRenderer);

  function ThreeSceneRenderer() {
    var _this;

    _classCallCheck(this, ThreeSceneRenderer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "resizeCanvasToDisplaySize", function () {
      var canvas = _this.renderer.domElement; // look up the size the canvas is being displayed

      var width = canvas.clientWidth;
      var height = canvas.clientHeight; // adjust displayBuffer size to match

      if (canvas.width !== width || canvas.height !== height) {
        // you must pass false here or three.js sadly fights the browser
        _this.renderer.setSize(width, height, false);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onCanvasLoaded", function (c) {
      if (c !== null) {
        _this.canvas = c;
      }
    });

    return _this;
  }

  _createClass(ThreeSceneRenderer, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      //Do not render() when props change, as props.scene changes should not result in DOM changes.
      return false;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      // Renderer
      this.renderer = new THREE.WebGLRenderer({
        alpha: true,
        antialias: true,
        canvas: this.canvas
      });

      if (this.props.gammaCorrect) {
        //Correct colors
        this.renderer.outputEncoding = THREE.GammaEncoding;
        this.renderer.gammaFactor = 2.2;
      }

      if (this.props.adaptToDeviceRatio) {
        this.renderer.setPixelRatio(window.devicePixelRatio);
      }

      window.addEventListener('resize', this.resizeCanvasToDisplaySize);
      this.resizeCanvasToDisplaySize();

      if (typeof this.props.onMount === 'function') {
        this.props.onMount({
          renderer: this.renderer,
          canvas: this.canvas
        });
      } else {
        console.error('onMount function not available');
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.resizeCanvasToDisplaySize);

      if (typeof this.props.onUnmount === 'function') {
        this.props.onUnmount();
      } else {
        console.error('onUnmount function not available');
      }

      this.renderer.forceContextLoss();
      this.renderer = null;
    }
  }, {
    key: "render",
    value: function render() {
      // 'rest' can contain additional properties that you can flow through to canvas:
      // (id, className, etc.)
      var _this$props = this.props,
          width = _this$props.width,
          height = _this$props.height,
          rest = _objectWithoutProperties(_this$props, ["width", "height"]);

      var opts = {};

      if (width !== undefined && height !== undefined) {
        opts.width = width;
        opts.height = height;
      }

      return /*#__PURE__*/_react.default.createElement("canvas", _extends({}, opts, {
        className: (0, _classnames.default)('three-scene-renderer', this.props.className),
        ref: this.onCanvasLoaded
      }));
    }
  }]);

  return ThreeSceneRenderer;
}(_react.default.Component);

var _default = ThreeSceneRenderer;
exports.default = _default;

//# sourceMappingURL=ThreeSceneRenderer.js.map